export class UserprofileUpdateVM {
    uuid: string;
    homeStreet: string;
    homeCityID: number;
    homeStateID: number;
    homeCountryID: number;
    businessStreet: string;
    businessCityID: number;
    businessStateID: number;
    businessCountryID: number;
    profileImage: string;
    imageName: string;
    instantMessenger: string;
    twitterUrl: string;
    facebookUrl: string;
    websiteUrl: string;
    createdBy: number;
    databaseID: number;
}
